<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
      <simple-wizard :is-modal="isModal" :is-edit="isEdit" :go-next="goNext" @close="handleClose">
        <template slot="header">
          <h5 class="category">
            <span style="font-weight: 500; color: #1f5aff">Globe</span>
            <span style="font-weight: 700; color: #555">Chek</span>&nbsp;
            <span style="font-weight: 400; color: 222">{{ pageTitle }}</span>
            <hr style="margin-top: 20px" />
          </h5>
        </template>

        <wizard-tab :before-change="validateStep">
          <template slot="label">{{ defineLabel }}</template>
          <first-step
            ref="step1"
            :is-edit="isEdit"
            @on-validated="onStepValidated"
          />
        </wizard-tab>
      </simple-wizard>
    </div>
    <loader :is-visible="isLoading" />
  </div>
</template>
<script>
import FirstStep from "./Wizard/Admin_Registration/1_AdminDetails.vue"
import { SimpleWizard, WizardTab } from "@/components"
import loader from "@/components/GlobeChek/loader.vue"
export default {
  components: {
    FirstStep,
    SimpleWizard,
    WizardTab,
    loader
  },
  props: {
    userType: { type: String, default: "Admin" },
    doctor: { type: Object, default: null },
    isEdit: { type: Boolean, default: false },
    isModal: { type: Boolean, default: false },
    isCreateAdmin: { type: Boolean, default: false }
  },
  data() {
    return {
      wizardModel: {},
      goNext: false,
      isLoading: false
    }
  },
  computed: {
    pageTitle() {
      return `${this.isEdit ? "Edit" : ""} ${this.userType}${this.isEdit ? " Details" : ""} ${this.isEdit ? "" : "Registration"}`
    },
    isPhone() {
      return window.screen.width < 760
    },
    screenWidth() {
      return window.screen.width
    },
    defineLabel() {
      return this.isCreateAdmin ? "Admin details" : "Technician details"
    }
  },
  methods: {
    async validateStep() {
      const valid = await this.$refs.step1.validate()
      if (valid) {
        this.wizardComplete()
        return true
      }
      return false
    },
    onStepValidated(validated, model) {
      if (validated) {
        this.wizardModel = { ...this.wizardModel, ...model }
      }
    },
    wizardComplete() {
      this.$emit("complete", this.wizardModel)
    },
    handleClose() {
      this.$emit("close")
    }
  }
}
</script>
